import { useLocation } from 'react-router-dom';

export const useLanguage = () => {
  const location = useLocation();
  
  // Detecta se está na rota /presentation (inglês) ou /apresentacao (português)
  const isEnglish = location.pathname.startsWith('/presentation');
  
  return {
    lang: isEnglish ? 'en' : 'pt',
    isEnglish,
    isPortuguese: !isEnglish
  };
};
